/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     模型 API
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const DIM_host = process.env.VUE_APP_PHP_DIM_API_HOST;
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function getAllDevApi(params) {
  return request({
    url: jsApiHost + '/dev/summary/list',
    method: 'get',
    params
  })
}

export function getPublicDevApi() {
  return request({
    url: '?c=dev&a=dev&do=public',
    method: 'get'
  })
}

export function getPrivateDevApi() {
  return request({
    url: '?c=dev&a=dev&do=private',
    method: 'get'
  })
}

export function getDevListApi(params) {
  return request({
    url: '?c=dev&a=dev&do=list',
    method: 'get',
    params
  })
}

export function getDevProfileApi(devid) {
  return request({
    url: '?c=dev&a=dev&do=get',
    method: 'get',
    params: {
      devid
    }
  })
}

export function postDevProfileApi(data) {
  return request({
    url: '?c=dev&a=dev&do=create',
    method: 'post',
    data
  })
}

export function getDevModelApi(devid) {
  return request({
    url: '?c=dev&a=dev&do=model',
    method: 'get',
    params: {
      devid
    }
  })
}

export function syncDevApi(devid) {
  return request({
    url: '?c=dev&a=dev&do=sync',
    method: 'post',
    data: {
      devid
    }
  })
}

export function cloneDevApi(devid, name) {
  return request({
    url: '?c=dev&a=dev&do=clone',
    method: 'post',
    data: {
      devid,
      name
    }
  })
}

export function deleteDevApi(devids) {
  return request({
    url: '?c=dev&a=dev&do=delete',
    method: 'post',
    data: {
      devids
    }
  })
}

export function importDevApi(data) {
  return request({
    url: '?c=dev&a=csv&do=import',
    method: 'post',
    data
  })
}

export function editDevProfileApi(data) {
  return request({
    url: DIM_host + '?c=dev&a=dev&do=post',
    method: 'post',
    data
  })
}

export function devPostApi(data) {
  return request({
    url: `${ jsApiHost }/dev/post`,
    method: 'post',
    data
  })
}


export function brandGetAllApi(params) {
  return request({
    url: jsApiHost + '/dev/brand/getAll',
    method: 'get',
    params
  })
}

export function categoryGetAllApi(params) {
  return request({
    url: jsApiHost + '/dev/category/getAll',
    method: 'get',
    params
  })
}

export function devGetApi(params) {
  return request({
    url: jsApiHost + '/dev/get',
    method: 'get',
    params
  })
}

export function devTransferApi(data) {
  return request({
    url: `?c=dev&a=dev&do=transfer`,
    method: 'post',
    data
  })
}

export function devSchemeUpdateApi(data) {
  return request({
    url: jsApiHost + '/dev/default/rms/scheme/update',
    method: 'post',
    data
  })
}
